import axios from 'axios';
import urlList from '@utils/urlList';
import { getMockBossStoreSelected, getMockOrder } from './mockUtils';
import JSZip from 'jszip';

/* ITEMS */
export const deleteOrderItem = async (hostname: string, data: object) => {
    return new Promise((resolve, reject) => {
      const url = hostname + urlList['DELETE_ORDER_ITEM'] + '?nocache=' + new Date().getTime();
  
        if(url) {
          axios({
            url,
            method: 'PUT',
            data: data,
            withCredentials: true
          })
          .then((res: any) => {
            resolve(res.data);
          })
          .catch((err: any) => {
            reject(err.response);
          })
        }
      });
  }

export const getPrescription = async (hostname: string, orderItemId: string) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['GET_PRESCRIPTION'] + '/' + orderItemId + '?nocache=' + new Date().getTime();

      if(url) {
        axios({
          url,
          method: 'GET',
          withCredentials: true,
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
    });
}

export const sendPrescription = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['SEND_PRESCRIPTION'] + '?nocache=' + new Date().getTime();

    if(url) {
      axios({
        url,
        method: 'PUT',
        data: data,
        withCredentials: true
      })
      .then((res: any) => {
        resolve(res);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  });
}

/* ADD TO CART */
export const addToCart = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['ADD_TO_CART'];

    if(url) {
      axios({
        url,
        method: 'POST',
        data: data,
        timeout: 10000,
      })
      .then((response: any) => {
        if(response.errorCode === undefined) {
          resolve(response.data);
        } else {
          console.error(response.errorCode);
        }
      })
      .catch((err: any) => {
        reject(err);
      })
    }
  });
}

/* CALCULATE INSURANCE BENEFIT */
export const calculateProductInsuranceBenefit = async (hostname: string, catalogId: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['CALCULATE_INSURANCE_BENEFIT'].replace('##CATALOGID##', catalogId);

    if(url) {
      axios({
        url,
        method: 'POST',
        data: data,
        timeout: 40000,
      })
      .then((response: any) => {
        resolve(JSON.parse(response.data.__PAIR_DISCOUNT));
      })
      .catch((err: any) => {
        reject(err);
      })
    }
  });
}
  
/* SHIPPING INFO */
export const updateShippingInfo = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['UPDATE_SHIPPING_INFO'] + '?nocache=' + new Date().getTime();
  
      if(url) {
        axios({
          url,
          method: 'PUT',
          data: data,
          withCredentials: true
        })
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
}

/* PROMO CODE */
export const postPromoCode = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['POST_PROMO_CODES'] + '?nocache=' + new Date().getTime();

    if(url) {
      axios({
        url,
        method: 'POST',
        data: data,
        withCredentials: true
      })
      .then((res: any) => {
        if(res.status === 201) {
          resolve(true);
        }
      })
      .catch((err: any) => {
        reject(err);
      })
    }
  });
}

export const deletePromoCode = async (hostname: string, code: string) => {
    return new Promise((resolve, reject) => {
        const url = hostname + urlList['DELETE_PROMO_CODES'] + '/' + code + '?nocache=' + new Date().getTime();
    
        if(url) {
          axios({
            url,
            method: 'DELETE',
            withCredentials: true
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err: any) => {
            reject(err.response);
          })
        }
      });
}

/* ITEM PROPERTIES */
export const getItemProperties = async (url: string) => {
    return new Promise((resolve, reject) => {          
        if(url) {
          url = url.replace('/wcs/', '/search/') + '?profileName=RONA_findProductByIds_Summary';
          axios({
            url,
            method: 'GET',
            withCredentials: true
          })
          .then((res: any) => {
            resolve(res.data);
          })
          .catch((err: any) => {
            reject(err.response);
          })
        }
    });
}

/* CATEGORY ID */
export const getCategoryId = async (url: string) => {
  return new Promise((resolve, reject) => {          
      if(url) {
        url = url.replace('/wcs/', '/search/');
        axios({
          url,
          method: 'GET',
          withCredentials: true
        })
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
}

/* ADDRESS */
export const postAddress = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['ADD_ADDRESS']  + '?nocache=' + new Date().getTime();
  
      if(url) {
        axios({
          url,
          method: 'PUT',
          data: data,
          withCredentials: true
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
}

/* POST ADDRESS BOSS */
export const postAddressBoss = async (hostname: string, storeId: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['ADD_ADDRESS_BOSS'].replace('##STOREID##', storeId)  + '?nocache=' + new Date().getTime();
  
      if(url) {
        axios({
          url,
          method: 'POST',
          data: data,
          withCredentials: true
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
}

export const validateAddress = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['VALIDATE_ADDRESS']  + '?nocache=' + new Date().getTime();
    
    if(url) {
      axios({
        url,
        method: 'PUT',
        data: data,
        withCredentials: true
      })
      .then((res: any) => {
        resolve(res);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  })
}

/* PAYMENT */
export const addPayment = async(hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['ADD_PAYMENT']  + '?nocache=' + new Date().getTime();

      if(url) {
        axios({
          url,
          method: 'PUT',
          data: data,
          withCredentials: true
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
}

export const preparePayment = async(hostname: string, data = {}) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['PREPARE_PAYMENT']  + '?nocache=' + new Date().getTime();

      if(url) {
        axios({
          url,
          method: 'PUT',
          data: data,
          withCredentials: true
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
}

export const submitPayment = async(hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['SUBMIT_PAYMENT']  + '?nocache=' + new Date().getTime();

    if(url) {
      axios({
        url,
        method: 'POST',
        data: data,
        withCredentials: true
      })
      .then((res: any) => {
        resolve(res);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  });
}

export const getOrder = async(mockRequests: boolean, hostname:string, orderId: string, email: string) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['GET_ORDER'] + '/' + orderId + '?email=' + encodeURIComponent(email)  + '&nocache=' + new Date().getTime();

      if(url) {
        return(mockRequests 
          ? getMockOrder() :
        axios({
          url,
          method: 'GET',
          withCredentials: true,
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }))
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err);
        })
      }
    });
}

export const getCartForAddressId  = (mockRequests: boolean, hostname: string) => {
  return new Promise((resolve, reject) => {
      const url = hostname + urlList['GET_CART'] + '?nocache=' + new Date().getTime();
      
      if(url) {
        axios({
          url,
          method: 'GET',
          withCredentials: true,
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
};



/* BOSS */
export const fetchPhysicalStores = async (hostname: string, storeId: string, lat: string, lng: string, data: object, radius: string) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['URL_GET_STORE_BOSS'].replace('##STOREID##', storeId).replace('##LAT##', lat).replace('##LNG##', lng).replace('##RADIUS##', radius).replace('##PAGESIZE##', radius);

    if(url) {
        axios({
        url,
        method: 'POST',
        data: data
        })
        .then((res) => {
            resolve(res.data);
        })
        .catch((err) => {
            reject(err.response);
        })
    }
    });
}


/* ESPOT */

export const getEspot = (hostname: string, espotName: string) => {

  return new Promise((resolve, reject) => {
    const url = hostname + urlList['GET_ESPOT']  + espotName + '?nocache=' + new Date().getTime();
    if(url) {
      axios({
        url,
        method: 'GET',
        withCredentials: true
      }).then((response: any) => {
        let res = response?.data?.MarketingSpotData?.[0]?.baseMarketingSpotActivityData?.[0]?.marketingContentDescription?.[0]?.marketingText.replace("[environmentDomain]", config.hostname+'/gl-us');
        resolve(res);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  })

}

/* POST BOSS DELIVER HERE */
export const setBossShipping = async (hostname: string, storeId: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['URL_SET_STORE_BOSS'].replace('##STOREID##', storeId);

    if(url) {
        axios({
        url,
        method: 'POST',
        data: data,
        headers: {
          'Content-Type': 'application/json'
        },
        })
        .then((res) => {
            resolve(res.data);
        })
        .catch((err) => {
            reject(err.response);
        })
    }
    });
}

export const getBossStoreSelected = async (mockRequests: boolean, hostname: string, storeId: string, identifier: string) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['URL_GET_STORE_BOSS_SELECTED'].replace('##STOREID##', storeId).replace('##IDENTIFIER##', identifier);

    if(url) {
        mockRequests ? 
         getMockBossStoreSelected()
         .then((res) => {
          resolve(res.data);
          })
          .catch((err) => {
              reject(err.response);
          })
        : axios({
        url,
        method: 'GET'
        })
        .then((res) => {
            resolve(res.data);
        })
        .catch((err) => {
            reject(err.response);
        })
    }
    });
}

export const getLensPackages = (hostname: string, frameId: string, catalogId: string) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['GET_LENSES'].replace('##FRAMEID##', frameId).replace('##CATALOGID##', catalogId);
    if(url) {
      axios({
        url,
        method: 'GET',
      }).then((response: any) => {
        resolve(response.data.response.data);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  })
}

export const getLensPackagesDataManager = (hostname: string, frameMoco: string) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['GET_LENS_PACKAGES_DATAMANAGER'].replace('##FRAMEID##', frameMoco);
    if(url) {
      axios.get(url,
        {
          responseType: "arraybuffer",
          decompress: true,
        }
      ).then(async (res: any) => {
        const zip = new JSZip();
        const extractedFiles = await zip.loadAsync(res.data);
        const jsonResults = await Promise.all(
          Object.keys(extractedFiles.files).map(async (filename) => {
            const content = await zip.file(filename)?.async("string");
            if(content) {
              let contentJsonFiltered = Object.entries(JSON.parse(content).packages).filter(([_, value]) => value.length > 0).reduce((acc, [key, value]) => {
                acc[key] = value[0];
                return acc;
              }, {});
              return contentJsonFiltered;
            }
          })
			);
			resolve(jsonResults[0]);
    }).catch((err: any) => {
			reject(err);
		})
    }
  })
}

export const addWarranty = (hostname: string, warrantyServiceParams) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['ADD_WARRANTY'];

    if(url) {
      axios({
        url,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: warrantyServiceParams,
      }).then((response: any) => {
        resolve(response.data);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  })

}

export const orderCalculate = (hostname: string, data: String) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['ORDER_CALCULATE'];

    if(url) {
      axios({
        url,
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: data,
      }).then((response: any) => {
        resolve(response.data);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  })

}

export async function getBrandSeoUrl(hostname: string, storeId: string, catalogId: string, brandIdentifier: string) {
    const encodedBrandIdentifier = encodeURIComponent(brandIdentifier);
    const url = hostname + `/wcs/resources/store/` + storeId + `/catalog/` + catalogId + `/seourl/brand/gl_brand_${encodedBrandIdentifier}`;
    try {
        const response = await axios.get(url);

        return response.data.response.SEOUrl;
    } catch (error) {
        console.error("Error fetching brand url:", error);
        throw error;
    }
}